import { Can } from 'providers/casl'

export const onTagAccess = (can: Can) => {
  can('access', 'TagPage-download')
}
